// node modules
import React from 'react';
import { observer } from 'mobx-react';
import { useStore } from 'modules/Stores';
// ui library
import { View, Text } from '@upstox/upstox-ui';
// images
import compass from 'assets/compass.png';
import bell from 'assets/bell.png';
// styles
import * as css from './style';

type EmptyStateProps = {
  title: TranslationKey;
  description?: TranslationKey;
  paddings?: ViewProps['padding'];
};

const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  paddings = [48, 24],
}) => {
  const { translate } = useStore('LocaleStore');
  const isEmptySearchResult = title === 'NO_RESULTS';

  return (
    <View
      flex
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      padding={paddings}
      data-qa={title}
    >
      <View css={css.image} cssProps={{ isEmptySearchResult }}>
        <img src={isEmptySearchResult ? bell : compass} alt="Compass" />
      </View>

      <Text variant="bodyBold">{translate(title)}</Text>

      {description && (
        <Text variant="meta" align="center">
          {translate(description)}
        </Text>
      )}
    </View>
  );
};

export default observer(EmptyState);
